@if (headline && showHeadline) {
  <div class="mx-3 mb-2 uppercase text-10 bold">{{ headline }}</div>
}
<div
  class="layout-fr-auto p-4 border-radius-4 gap-2 pointer wrapper h-100"
  [class]="contentStyleClass"
  [class.active]="isActive"
  [routerLink]="link"
  [queryParams]="queryParams"
  (click)="link && $event.stopPropagation()">
  <ng-content />
  @if (showArrowIcon) {
    <div>
      <shared-icon class="fill-primary align-self-start" icon="alt-arrow-right" width="1rem" height="1rem" />
    </div>
  }
  <div class="bottom span-column-2"><ng-content select="[bottom]" /></div>
</div>
<div
  class="subCard w-100 bg-orange-100 pt-5 mt--3 border-radius-bottom-3 p-3 z-index-0 flex align-items-center gap-1 text-16 box-shadow pointer"
  [class]="subCardClass"
  [routerLink]="subCardLink">
  <ng-content select="[subCard]" />
</div>
